import ContentHeader from "./content-header.component";

export default ContentHeader;
